module.exports = __webpack_public_path__ + "static/media/guide_traffic_map.4712274a.jpg";